import styled from "styled-components";
import ProjectTypes from "../../enums/ProjectTypes";

type IBorderColors = {
  [key in ProjectTypes]?: string;
} & {
  default: string;
};

export const Colors: IBorderColors = {
  [ProjectTypes.Allocation]: "#49ea14",
  [ProjectTypes.Factory]: "#164af3",
  [ProjectTypes.Corrective]: "#f39016ff",
  [ProjectTypes.Incident]: "#993399",
  [ProjectTypes.Internal]: "#f316f3",
  [ProjectTypes.TimeBank]: "#0eb1b1",
  default: "#f39016ff",
};

export const Page = styled.div`
  width: 100%;
  background: white;
  padding-top: 20px !important;
  border-radius: 10px !important;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 74vh;
  min-width: 100%;
  overflow-x: scroll;
  background-color: #fff;
  flex-wrap: wrap;
  gap: 10px;
  padding: 5px 10px;
`;

export const PageTitle = styled.p`
  font-weight: 600;
  color: rgba(37, 36, 36, 0.7);
  font-size: 1.25rem;
  padding-left: 24px;
`;

export const ContentAction = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
  margin-inside: 24px;
  margin-bottom: 24px;
`;

export const Title = styled.p`
  font-size: 1rem !important;
`;

export const Footer = styled.p`
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0 !important;
`;

export const Description = styled.p``;

export const Identifier = styled.p`
  width: 100%;
  border-bottom: 1px solid #dbdbdb;
`;

export const CardScroll = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  height: 100%;
  padding-bottom: 20px;
`;

export const CardBoard = styled.div`
  background: #fff;
  border: 2px solid #d9d9d9;
  height: 100%;
  width: 250px;
  min-width: 250px;
  border-radius: 10px;

  & > p {
    white-space: nowrap;
    color: #f39016ff;
    padding: 10px;
    text-align: center;
    font-size: 1.5rem;
  }
`;

export const Content = styled.div`
  padding: 10px;
  height: 85%;
  overflow-y: auto;
`;

export const Card = styled.div<{ typeProjectColor?: ProjectTypes }>`
  background: white;
  color: black;
  border-radius: 10px;
  border: 2px solid
    ${({ typeProjectColor }) =>
      Colors[(typeProjectColor as ProjectTypes) || "default"]};
  padding: 10px;
  box-shadow: 0 0 4px
    ${({ typeProjectColor }) =>
      Colors[(typeProjectColor as ProjectTypes) || "default"]};
  transition: 0.3s;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  &:hover {
    box-shadow: 0 0 10px
      ${({ typeProjectColor }) =>
        Colors[(typeProjectColor as ProjectTypes) || "default"]};
    /*background: #f8f8f8;*/
  }
`;
